import { app, store } from '../index'
// import { loginhandler } from '../actions/loginhandler'
import { LoginService } from './loginservice'
export function AuthLogin (params) {
  return app
    .authenticate(params)
    .then(payload => {
      // store.dispatch(loginhandler('login'))
      console.log('JWT Payload', payload)
      console.log(payload.userId)
      LoginService(payload.userid)
    })
    .catch(err => err)
}



// WEBPACK FOOTER //
// ./src/services/auth-service.js